export const version = "strings/5.8.0";
//# sourceMappingURL=_version.js.map